import {
  Divider as MuiDivider,
  DividerProps as MuiDividerProps,
} from '@mui/material';
import { FC } from 'react';

/* eslint-disable-next-line */
export interface DividerProps extends MuiDividerProps {}

export const Divider: FC<DividerProps> = ({ children }: DividerProps) => {
  return <MuiDivider>{children}</MuiDivider>;
};

export default Divider;
